// import request from './request'
import request from "axios"
import { param } from "jquery"
import qs from 'qs'

export default {
    //实例
    // ---------------------------------------------------  公共接口   -----------------------------------------------------------
    // 图片服务接口
    fileUpload: params => request.post('/api/fileUpload', params, false),
    // 保存修改
    confirmSetPsw: params => request.post('/api//retrievePassWord', params, false),
    // 获取验证码
    getCode: params => request.post('/api/getPhoneCode', params, false),
    // 实名认证
    authentication: params => request.post('/api/office/realName', params, false),
    // 获取省份
    getProvinces: params => request.post('/area/province', params, false),
    // 获取城市
    getCity: params => request.post('/area/city', params, false),
    // 获取县
    getCount: params => request.post('/area/county', params, false),
    //查询银行(总)
    queryBank: params => request.post('/bank/queryBank', params, false),
    // 查询支行
    querOpenBank: params => request.post('/bank/querySubBank', params, false),
    // 修改密码获取用户
    getUser: params => request.post('/api/getSysUser ', params, false),
    // 机构重置密码回显
    getOfficeResetPwd: params => request.post('/api/office/getOfficeResetPwd', params, false),
    // 重置密码
    resetPwd: params => request.post('/api/office/resetPwd', params, false),
    // 用户管理重置密码回显
    getUserResetPwd: params => request.post('/api/sys/user/getUserResetPwd', params, false),
    // 用户管理重置密码
    userResetPwd: params => request.post('/api/sys/user/resetPwd', params, false),
    // 查询地区
    querySysCountryList: params => request.post('/api/common/querySysCountryList', params, false),

    // 审核
    uploadBusOrders: params => request.post('/api/business/batchBrand', params, false),



    // 分享注册页
    // bannerH5Log: params => request.post('/api/common/v1/bannerH5Log', params, false),
    // ---------------------------------------------------  商品模块   -----------------------------------------------------------
    // 商品管理、品牌管理、品牌列表
    handleSelectList: params => request.post('/api/brand/list', params, false),
    // 商品管理、创建品牌
    setBrand: params => request.post('/api/brand/getUpdateBrand', params, false),
    // 商品管理 品牌列表 品牌停用
    stopBrand: params => request.post('/api/brand/changeStatus', params, false),
    // 商品管理 商品类型 列表
    shopTypeList: params => request.post('/api/brand/productTypelist', params, false),
    //商品管理 商品类型 查看
    catShopType: params => request.post('/api/brand/queryProductType', params, false),
    //商品管理 商品类型 商品列表 修改
    setShopList: params => request.post('/api/brand/queryProductType', params, false),
    //商品管理 商品类型 商品列表 停启用
    stopShopTypeList: params => request.post('/api/brand/changeProductTypeStatus', params, false),
    // 商品管理 商品列表 列表
    shopLister: params => request.post('/api/brand/cascadeProductType', params, false),
    // 商品管理 商品列表 列表 移动
    shopListMove: params => request.post('/api/product/changeSort', params, false),
    // 商品管理 添加商品
    addShows: params => request.post('/api/product/save', params, false),
    // 商品管理 添加商品 品牌列表
    channelNameList: params => request.post('/api/brand/queryChannelNameList', params, false),
    // 商品管理 添加商品 商品类型
    // channelNameListType:params => request.post('/api/brand/cascadeProductType', params, false),
    // 商品管理 修改  回显接口
    echoShopData: params => request.post('/api/product/getUpdateProduct', params, false),
    echoShop: params => request.post('/api/brand/querySecondChannelTypeList', params, false),


    // 采购管理 政策列表
    getPurchaseList: params => request.post('/api/direct/policyInfoList', params, false),
    // 采购管理 政策列表 停用
    policyStop: params => request.post('/api/direct/updateStatus', params, false),
    // 采购管理 政策列表 创建政策
    createPolicy: params => request.post('/api/direct/updateStatus', params, false),
    // 采购管理 政策列表 创建政策 终端类型
    terminalType: params => request.post('/api/direct/getAllProductNoInfo', params, false),
    // 采购管理 政策列表 创建政策 产品类型
    getProductType: () => request.get('/api/direct/getProductType', false),
    // 采购管理 政策列表 创建政策 回显数据
    echoPolicyData: params => request.post('/api/direct/getUpdatePolicyInfo', params, false),
    // 采购管理 政策列表 创建政策
    addPloicy: params => request.post('/api/direct/addPolicyInfo', params, false),
    // 采购管理 采购单列表
    orderListl: params => request.post('/api/direct/directOrderList', params, false),
    // 采购管理  查看详情
    catOrderDetail: params => request.post('/api/direct/getDirectOrderDetail', params, false),


    // ---------------------------------------------------  活动管理    -----------------------------------------------------------
    // 活动管理 列表
    activeList: params => request.post('/api/active/activeOfficeDetail', params, false),
    // 活动管理 活动管理
    activeAdministration: params => request.post('/api/active/queryAllActiveList', params, false),
    // 活动管理 开通奖励 品牌
    activeBrand: params => request.post('/api/product/queryProductById', params, false),
    // 活动管理 排名奖励 添加活动
    addAdministrationa: params => request.post('/api/product/verifyProduct', params, false),
    // 活动管理 船舰活动 周期达标活动
    // getAllOfficeList:() => request.get('/api/product/verifyProduct', false),
    // 活动管理 次月达标
    getAllOfficeLista: params => request.post('/api/office/getAllOfficeList', params, false),
    // 活动管理 定时达标 完成
    saveToTimeAmtActivel: params => request.post('/api/active/saveToTimeAmtActive', params, false),

    saveOpenRewordActive: params => request.post('/api/active/saveOpenRewordActive', params, false),
    saveNextMonthAmtActive: params => request.post('/api/active/saveNextMonthAmtActive', params, false),
    // ---------------------------------------------------  我的信息   -----------------------------------------------------------
    // 我的信息-基本、账户信息
    getUpdateOfficeInfo: params => request.post('/api/office/getUpdateOfficeInfo', params, false), //fromdata
    // 实名
    queryUpdateRealName: params => request.post('/api/office/queryUpdateRealName', params, false),
    // 我的信息-安全信息
    updatePassWord: params => request.post('/api/sys/user/updatePassWord', params, false),
    // 我的信息-充值提现记录
    querySubWithdrawlist: params => request.post('/api/recharge/querySubWithdrawlist', params, false),
    // 我的信息-充值提现记录详情
    queryWithdrawDedail: params => request.post('/api/recharge/queryWithdrawDedail', params, false),
    // 我的信息-提现展示
    withdrawForm: params => request.post('/api/recharge/withdrawForm', params, false),
    // 我的信息-提现提交
    subWithdrawForm: params => request.post('/api/recharge/subWithdrawForm', params, false),
    // 我的信息-充值表单展示
    // withdrawForm: params => request.post('/api/recharge/withdrawForm', params, false),
    // 我的信息-充值表单提交
    doRecharge: params => request.post('/api/recharge/doRecharge', params, false),
    // 我的信息-充值信息提交
    saveAdminAccount: params => request.post('/api/office/saveAdminAccount', params, false),
    // changeActiveStatus: params => request.post('/api/active/changeActiveStatus', params, false),


    // ---------------------------------------------------  活动管理   -----------------------------------------------------------
    // 机具列表查询
    queryProductActiveList: params => request.post('/api/active/queryProductActiveList', params, false),
    // 机具查看详情
    queryRewardDetail: params => request.post('/api/active/queryRewardDetail', params, false),
    // 修改活动状态
    changeStatus: params => request.post('api/active/changeStatus', params, false),
    // 机具列表导出
    productActiveExport: params => request.post('/api/active/productActive/excel/export', params, false),
    // 机具详情导出
    rewardDetailExport: params => request.post('/api/active/rewardDetail/excel/export', params, false),
    // 创建/修改机具活动
    saveProductActive: params => request.post('/api/active/saveProductActive', params, false),
    // 机具查询品牌
    queryChannelNameList: params => request.post('/api/brand/queryChannelNameList', params, false),
    // 机具查询品牌类型
    queryChannelTypeList: params => request.post('/api/brand/queryChannelTypeList', params, false),
    // 机具查询商品型号、单价
    productList: params => request.post('/api/product/list', params, false),
    // 机具查询商品型号、单价
    toChannelTypequeryProductList: params => request.post('/api/product/toChannelTypequeryProductList', params, false),
    // 机具修改前的查询（编辑）
    queryUpdateActive: params => request.post('/api/active/queryUpdateActive', params, false),
    // 模版管理
    shareMode: params => request.post('/api/template/queryShareList', params, false),
    // 模版管理 列表  查看
    seeShareMode: params => request.post('/api/template/querySysShare', params, false),

    // 开通达标
    // 达标活动列表查询
    queryPayActiveList: params => request.post('/api/active/queryPayActiveList', params, false),
    // 达标活动一级详情
    queryAgentInfo: params => request.post('/api/active/queryAgentInfo', params, false),
    // 达标活动二级详情
    queryProductInfo: params => request.post('/api/active/queryProductInfo', params, false),
    // 达标创建/修改
    savePayActive: params => request.post('/api/active/savePayActive', params, false),
    // 达标列表导出
    payActiveListExport: params => request.post('/api/active/payActiveList/excel/export', params, false),
    // 达标详情导出
    agentInfoExport: params => request.post('/api/active/agentInfo/excel/export', params, false),
    // 达标子详情导出
    productInfoExport: params => request.post('/api/active/productInfo/excel/export', params, false),

    // ------------------------------------------------------   系统设置   -------------------------------------------------------------
    // 系统设置 角色管理
    queryRoleByMenul: params => request.post('/api/sys/role/queryRoleByMenu', params, false),

    // ------------------------------------------------------   我的信息   -------------------------------------------------------------
    getUpdateOfficeInfol: params => request.post('/api/office/getUpdateOfficeInfo', params, false),

    // ------------------------------------------------商城管理----------------------------------
    // 库存列表
    mallList: params => request.post('/api/store/list', params, false),
    // 业务类型
    getOfficeAllBusInfo: params => request.post("api/business/getOfficeAllBusInfo", params, false),
    // 业务品牌
    getOfficeBusChannel: params => request.post("api/business/getOfficeBusChannel", params, false),
    // 推广名称
    getExtensionName: params => request.post("api/business/getBrandChannelType", params, false),
    // 卡等级
    getCardLeleve: params => request.post("/api/business/getCardLevelInfo", params, false),
    // 办卡状态
    getCardStatusInfo: params => request.post("/api/business/getCardStatusInfo ", params, false),
    // 入库
    exprotSnConfirm: params => request.post('/api/store/excel/exprotSnConfirm', params, false),
    // 入库 导入数据
    exprotSN: params => request.post('/api/store/excel/exprotSN', params, false),

    //库存明细 机具sim入库
    exprotSNSim: params => request.post('/api/store/excel/exprotSNSim', params, false),

    // 入库 商品名称
    mallProductById: params => request.post("/api/store/queryBusShopInfoList", params, false),
    // 库存列表批量导出
    mallExport: params => request.post('/api/mall/excel/export', params, false),
    // 库存品牌名称
    mallBrand: params => request.post('/api/brand/queryChannelNameList', params, false),
    // 机构库存统计列表
    stocktatisticsList: params => request.post("/api/mall/stocktatisticsList", params, false),
    // 库存品牌类型
    mallCommodity: params => request.post('/api/brand/cascadeProductType', params, false),
    // 库存详情
    storeDetailList: params => request.post('/api/store/storeDetailList', params, false),
    // 库存 出入库记录
    storeRecordListData: params => request.post('/api/mall/storeRecordListData', params, false),
    // 库存 修改库存状态
    updateStatus: params => request.post('/api/mall/updateStatus', params, false),
    // 库存明细 停用
    detailedStop: params => request.post("/api/store/updateSNStatus", params, false),
    // 库存明细 转让下拉框
    assignmentOfficeList: params => request.post("/api/office/getAllOfficeList", params, false),
    // 库存明细 转让搜索 新
    getOfficeByUid: params => request.post("/api/office/getOfficeByUid", params, false),
    // 库存明细 转让列表
    assignmentList: params => request.post("/api/mall/queryStoreDetailList", params, false),
    // 库存 修改库存状态
    changeActiveStatus: params => request.post('/api/active/changeActiveStatus', params, false),
    // 库存 商城订单
    orderList: params => request.post('/api/mall/orderList', params, false),
    // 库存 商城订单详情
    queryOrderDetail: params => request.post('/api/mall/queryOrderDetail', params, false),
    // 库存 订单派发
    queryOrderAllot: params => request.post('/api/mall/queryOrderAllot', params, false),
    // 库存新增
    mallSave: params => request.post('/api/store/save', params, false),
    // 库存 上/下架
    mallShopUpdate: params => request.post('/api/mall/shopUpdate', params, false),
    // 查询机构
    officeList: params => request.post('/api/office/list', params, false),
    // 库存 删除
    mallDeleteSn: params => request.post('/api/mall/deleteSn', params, false),
    // 库存 修改机具归属
    updateDeviceAffiliation: params => request.post('/api/store/updateDeviceAffiliation', params, false),
    // 库存 订单派发详情
    queryProductSN: params => request.post('/api/mall/queryProductSN', params, false),
    // 库存 订单派发
    distributeSn: params => request.post('/api/mall/distributeSn', params, false),
    // 库存 转让
    deviceTransfer: params => request.post('/api/mall/deviceTransfer', params, false),
    // 库存  售卖配置
    saleConfig: params => request.post("api/mall/saleConfig", params, false),
    // 库存  列表在架子状态  开关
    changeShopUpStatus: params => request.post("api/mall/changeShopUpStatus", params, false),
    // ----------------------------- 权益管理 ---------------------------------------------
    //权益列表 停用
    vipChangeStatus: params => request.post("/api/member/changeStatus", params, false),
    //权益列表
    vipList: params => request.post('/api/rgt/list', params, false),
    // 创建权益 配置权益特权
    saveUpdateCfg: params => request.post("/api/member/saveUpdateCfg", params, false),
    // 创建权益 配置权益升级规则
    saveUpdateRule: params => request.post("/api/member/saveUpdateRule", params, false),
    // 创建权益 配置图片
    saveMbrPhoto: params => request.post("/api/member/saveMbrPhoto", params, false),
    // 创建权益 品牌下拉框
    vipMemberChannel: params => request.post("/api/member/getMemberChannel", params, false),
    // 创建权益 回显
    vipSelMbrCfg: params => request.post("/api/member/selMbrCfg", params, false),
    // 机构权益 品牌名称
    vipBrandList: params => request.post("/api/brand/queryChannelNameList", params, false),
    // 机构权益 权益等级
    vipGrade: params => request.post("/api/member/queryMember", params, false),
    // 机构权益列表
    vipOfficeMerList: params => request.post('/api/rgt/level/query', params, false),
    // 机构权益列表 等级变更下拉框
    vipQueryMember: params => request.post('/api/member/queryMember', params, false),
    // 机构权益列表 等级变更
    vipUpdateMbr: params => request.post("/api/rgt/level/changeLevel", params, false),
    //权益变更记录 列表
    vipOrderList: params => request.post("/api/member/ajaxMbrPayOrderList", params, false),
    // 权益类型
    queryDictList: params => request.post("/api/sys/dict/queryDictList", params, false),

    //-----------------------  商户管理  ---------------------------
    // 商户列表
    merInfoList: params => request.post("/api/merchant/merInfoList", params, false),
    // 商户流水 列表
    teamMerDeal: params => request.post("/api/merchant/teamMerDeal", params, false),
    // 押金政策
    merPolicyCfgList: params => request.post("/api/merchant/merPolicyCfgList", params, false),
    // 添加押金政策
    saveMerPolicyCfg: params => request.post("/api/merchant/saveMerPolicyCfg", params, false),
    // 押金政策回显
    getMerPolicyCfg: params => request.post("/api/merchant/getMerPolicyCfg", params, false),
    // 停用启用
    updatePolicyStatus: params => request.post("/api/merchant/updatePolicyStatus", params, false),
    // 查询机构代理商
    queryOfficeList: params => request.post("/api/office/queryOfficeList", params, false),
    // 查询字典表中的数据
    queryDictList: params => request.post("/api/sys/dict/queryDictList",params,false),
    // 结算币种列表
    querySysCurrencyList: params => request.post("/api/common/querySysCurrencyList", params, false),
    // 修改商户状态
    updateMerStatus: params => request.post("/api/mer/updateMerStatus", params, false),
    // 新增、修改商户费率
    saveMerchantRate:params => request.post("/api/mer/saveMerchantRate", params, false),
    // 查询商户费率
    queryMerchantRateInfo: params => request.post("/api/mer/queryMerchantRateInfo", params, false),
    // 查询商户编码列表
    queryMerCodeList: params => request.post("/api/mer/queryMerCodeList", params, false),
    // 查询渠道商户下拉列表
    queryAcqMerList: params => request.post("/api/acqMer/queryAcqMerList", params, false),
    // 门店详情
    getMerStoreInfo: params => request.post("/api/merStore/getMerStoreInfo", params, false),
    // 修改门店状态
    updateMerStoreStatus: params => request.post("/api/merStore/updateMerStoreStatus", params, false),
    // 重置密码
    resetMerPwd: params => request.post("/api/mer/resetMerPwd", params, false),
    // 清算订单详情
    queryCalcInfo: params => request.post("/api/calc/queryCalcInfo", params, false),
    //交易结算划款预览
    previewSettleDetail: params => request.post("/api/paymentSettle/previewSettleDetail", params, false),
    // 交易结算批量划款
    batchTransfer: params => request.post("/api/paymentSettle/batchTransfer", params, false),
    // 交易结算批量审核
    batchCheckSettle: params => request.post("/api/paymentSettle/batchCheckSettle", params, false),
    //保证金结算划款预览
    previewSettleDetail2: params => request.post("/api/depositSettle/previewSettleDetail", params, false),
    // 保证金结算批量划款
    batchTransfer2: params => request.post("/api/depositSettle/batchTransfer", params, false),
    // 保证金结算批量审核
    batchCheckSettle2: params => request.post("/api/depositSettle/batchCheckSettle", params, false),
    // 批量重算支付结算批次明细
    paymentBatchReSettle: params => request.post("/api/paymentSettleDetail/paymentBatchReSettle", params, false),
    // 批量重算保证金结算批次明细
    depositBatchReSettle: params => request.post("/api/depositSettleDetail/depositBatchReSettle", params, false),
    // 支付渠道管理修改
    saveAcqInfo: params => request.post("/api/acq/saveAcqInfo", params, false),
    // 支付渠道状态修改
    updateAcqInfoStatus: params => request.post("/api/acq/updateAcqInfoStatus", params, false),
    // 支付渠道管理详情
    queryAcqInfo: params => request.post("/api/acq/queryAcqInfo", params, false),
    // 查询支付渠道列表
    queryAcqInfoList: params => request.post("/api/acq/queryAcqInfoList", params, false),
    // 渠道商户状态修改
    updateAcqMerStatus: params => request.post("/api/acqMer/updateAcqMerStatus", params, false),
    // 渠道商户信息详情
    queryAcqMerInfo: params => request.post("/api/acqMer/queryAcqMerInfo", params, false),
    // 渠道终端状态修改
    updateAcqTidInfoStatus:params => request.post("/api/acqTid/updateAcqTidInfoStatus", params, false),
    // 查询渠道终端信息
    queryAcqTidInfo: params => request.post("/api/acqTid/queryAcqTidInfo", params, false),

    // 批量导入黑名单
    batchImport: params => request.post("/api/risk/excel/batchImport", params, false),
    // 更新风控黑名单状态
    updateBlackListStatus: params => request.post("/api/risk/updateBlackListStatus", params, false),
    // 删除风控黑名单
    deleteBlackList: params => request.post("/api/risk/deleteBlackList", params, false),
    // 查询风控黑名单详情
    queryBlackList: params => request.post("/api/risk/queryBlackList", params, false),
    // 修改风控限额列表状态
    updateLimitDetailStatus: params => request.post("/api/risk/updateLimitDetailStatus", params, false),
    // 删除风控限额列表详情
    deleteLimitDetail: params => request.post("/api/risk/deleteLimitDetail", params, false),
    // 查询风控限额列表详情
    queryLimitDetail: params => request.post("/api/risk/queryLimitDetail", params, false),
    // 修改风控交易频次管理状态
    updatePaymentFrequencyStatus: params => request.post("/api/risk/updatePaymentFrequencyStatus", params, false),
    // 删除风控交易频次管理
    deletePaymentFrequency: params => request.post("/api/risk/deletePaymentFrequency", params, false),
    // 查询风控交易频次管理相关
    queryPaymentFrequency: params => request.post("/api/risk/queryPaymentFrequency", params, false),

    

    /* ---------------------- 终端管理 ---------------------- */
    // 查询终端信息
    queryMerTidInfotid: params => request.post("/api/tid/queryMerTidInfo", params, false),
    //修改终端状态
    updateMerTidInfoStatus: params => request.post('/api/tid/updateMerTidInfoStatus', params, false),
    //查询厂商列表
    queryBusShopFactoryInfoList: params => request.post('/api/tid/queryBusShopFactoryInfoList', params, false),
    // 根据商户号查询门店列表
    queryMerStoreInfoList: params => request.post('/api/merStore/queryMerStoreInfoList', params, false),
    // 查询终端号列表
    queryMerTidInfoListByMerCode: params => request.post('/api/tid/queryMerTidInfoListByMerCode', params, false),
    
    /* ---------------------- 拒付管理 ---------------------- */
    //拒付交易管理操作
    operationMerRefusalPayment: params => request.post('/api/refusalPayment/operationMerRefusalPayment', params, false),

    //-------------------------- 地区管理  ----------------------------------
    // 查询国家编码
    countryList: params => request.post("/api/common/querySysCountryList", params, false),
    
    //-------------------------- 数据统计  ----------------------------------
    //交易统计- 关键指标
    dataPayStatisticsCount: params => request.post("/api/dataStatistics/queryPayStatisticsCount", params, false),
    //交易统计- 饼图
    dataPayContrastCount: params => request.post("/api/dataStatistics/payContrastCount", params, false),
    //交易统计 - 折线图
    dataTradeStatistics: params => request.post("/api/dataStatistics/tradeStatistics", params, true),
    // 收支统计 -- 折线图
    moneyStatisticsQuery: params => request.post("/api/dataStatistics/moneyStatisticsQuery", params, false),
    // 收支统计- 关键指标
    moneyStatisticsTotalQuery: params => request.post("/api/dataStatistics/incomeStatisticsTotalQuery", params, false),
    // 收支统计 --饼图
    moneyContrastCount: params => request.post("/api/dataStatistics/incomeContrastCount", params, false),
    // 用户统计 -- 折线图
    userStatisticsQuery: params => request.post("/api/dataStatistics/userStatisticsQuery", params, false),
    // 用户统计 -- 关键指标
    userStatisticsTotalQuery: params => request.post("/api/dataStatistics/userStatisticsTotalQuery", params, false),
    // 交易订单详情
    queryTradeInfoData: params => request.post("/api/payment/queryTradeInfo",params,false),

    // 退款订单详情
    queryRefundInfo: params => request.post("/api/refund/queryRefundInfo",params,false),

    // -------------------------------  账户管理  -----------------------------------
    // 账户管理 列表
    accountList: params => request.post("/api/account/ajaxAccountList", params, false),
    getAccountInfo: params => request.post("/api/account/getAccountInfo", params, false),
    // 充值记录
    getRechargeRecord: params => request.post('/api/recharge/queryOfficeInOrderList', params, false),
    // 提现记录
    querySprataWithdrawOrderList: params => request.post('/api/account/querySprataWithdrawOrderList', params, false),

    //查询出款账户明细
    echoList: params => request.post("/api/account/EchoList", params, false),
    //提现数据回显
    subWithdraw: params => request.post("/api/account/subWithdraw", params, false),
    // 提现
    getDrawInfo: params => request.post("/api/account/getDrawInfo", params, false),
    // 账户管理 差错
    updateAccountInfo: params => request.post("api/account/updateAccountInfo", params, false),
    //总机构 预充账户明细 调账
    updatePrechargeAccountInfo: params => request.post("api/account/updatePrechargeAccountInfo", params, false),
    //划拨
    transferPrechargeAccount: params => request.post("api/account/transferPrechargeAccount", params, false),
    // 账户管理 停用启用
    accountChange: params => request.post("/api/account/changeStatus", params, false),
    // 流水明细 列表
    transactionsList: params => request.post("/api/account/transactionsList", params, false),
    // 提现明细
    queryWithdrawList: params => request.post('/api/account/queryWithdrawList', params, false),
    // 提现明细 审核
    auditWithdraw: params => request.post('/api/account/auditWithdraw', params, false),
    // 通道列表
    queryChannelList: params => request.post('/api/channel/queryChannelList', params, false),
    // 通道 新增/修改
    saveChannel: params => request.post('/api/channel/saveChannel', params, false),
    // 通道 回显
    queryUpdateChannel: params => request.post('/api/channel/queryUpdateChannel', params, false),
    // 通道 停用/启用
    channelUpdateStatus: params => request.post('/api/channel/updateStatus', params, false),
    // 通道流水查询
    queryChannelDeal: params => request.post('/api/channel/queryChannelDeal', params, false),
    // 账户管理-分润明细
    queryEarnDetail: params => request.post('/api/account/queryEarnDetail', params, false),
    // 账户管理-出款管理列表
    queryRepayList: params => request.post('/api/repay/queryRepayList', params, false),
    // 账户管理-申请额度
    repayDetail: params => request.post('/api/repay/repayDetail', params, false),
    // 账户管理-申请额度提交
    updaterepay: params => request.post('/api/repay/updaterepay', params, false),
    // 查询通道
    queryChannel: params => request.post('/api/channel/queryChannel', params, false),
    // 充值管理-列表
    queryRechargelist: params => request.post('/api/recharge/queryRechargelist', params, false),
    // 充值管理-列表详情
    doRechargeDetail: params => request.post('/api/recharge/doRechargeDetail', params, false),
    // 充值管理-审核
    doRechargeAuditing: params => request.post('/api/recharge/doRechargeAuditing', params, false),


    // ------------------------------------------------------   O单管理------------------------------
    // 首页定制-首页
    queryMenuList: params => request.post('/api/made/queryMenuList', params, false),
    // 首页定制-保存
    saveMenuInfo: params => request.post('/api/made/saveMenuInfo', params, false),
    // 首页定制-上传  保存/编辑
    uploadMenuInfo: params => request.post('/api/made/uploadMenuInfo', params, false),
    // 首页定制
    statusMenuInfo: params => request.post('/api/made/statusMenuInfo', params, false),
    // 背景定制-查询
    queryBackGround: params => request.post('/api/made/queryBackGround', params, false),
    // 背景定制-删除
    delBackGround: params => request.post('/api/made/delBackGround', params, false),
    // 背景定制-保存
    saveBackGround: params => request.post('/api/made/saveBackGround', params, false),

    // ------------------------------------------------------   系统设置   -------------------------------------------------------------
    // 角色列表查询
    queryRolelist: params => request.post('/api/sys/role/getRolelist', params, false),
    // 角色列表详情
    queryRoleDetail: params => request.post('/api/sys/role/queryRoleDetail', params, false),
    // 角色修改增加和是否停用修改
    saveUpdateRole: params => request.post('/api/sys/role/saveOrUpdateRole', params, false),
    // 查询是否有未设置的权限
    queryRoleByMenu: params => request.post('/api/sys/role/queryRoleByMenu', params, false),
    // 角色加入权限
    addRoleByMenu: params => request.post('/api/sys/role/addRoleByMenu', params, false),
    // 权限列表
    querySysMenulist: params => request.post('/api/sys/menu/querySysMenulist', params, false),
    // 添加权限/修改权限/修改状态
    saveUpdateMenu: params => request.post('/api/sys/menu/saveUpdateMenu', params, false),
    // 权限查询详情
    queryMenuDetail: params => request.post('/api/sys/menu/queryMenuDetail', params, false),
    // 所有父级列表
    queryMenuParentIds: params => request.post('/api/sys/menu/queryMenuParentIds', params, false),
    // 查询用户列表
    userList: params => request.post('/api/sys/user/list', params, false),
    // 添加/修改用户
    userSave: params => request.post('/api/sys/user/saveOrUpdateUser', params, false),
    // 查看用户详情
    queryUpdateUser: params => request.post('/api/sys/user/queryUpdateUser', params, false),
    // 查询角色分配的信息
    queryRoleDistributor: params => request.post('/api/sys/user/queryRoleDistributor', params, false),
    // 角色分配
    roleDistributor: params => request.post('/api/sys/user/roleDistributor', params, false),
    // 修改用户状态
    userUpdateStatus: params => request.post('/api/sys/user/updateStatus', params, false),
    // 短信管理
    smsList: params => request.post('/api/sys/sms/list', params, false),

    //所属公司
    // gongsi : params => request.post('/api/office/queryOfficeList',params,false)

    // ----------------------------- APP管理 ---------------------------------------------
    // 列表接口
    querySysCltMenulist: params => request.post('/api/sys/cltMenu/querySysCltMenulist', params, false),
    // 添加轮播图功能指向下拉框
    queryInternalJump: params => request.post("/api/template/queryInternalJump", params, false),

    // 系统日志
    sysLogList: params => request.post('/api/sysLog/list', params, false),

    //---------------------------------------业务管理--------------------------------------------------
    // 贷款订单
    getBusLoanList: params => request.post('/api/busLoan/getBusLoanList', params, false),
    // 贷款订单查看
    getBusLoanInfo: params => request.post('/api/busLoan/getBusLoanInfo', params, false),
    // 业务类型
    uploadBusOrder: params => request.post('/api/uploadBusOrder', params, false),
    // 业务类型
    uploadLoanOrder: params => request.post('/api/uploadLoanOrder', params, false),
    // 贷款类型
    getLoanStatusInfo: params => request.post('/api/busLoan/getLoanStatusInfo', params, false),
    // 业务品牌模糊查询
    getAllChannel: params => request.post('/api/business/getAllChannel', params, false),
    // 品牌通道
    getChannelByUp: params => request.post('/api/busUpChannel/getChannelByUp', params, false),
    // 品牌
    getAllUpChannel: params => request.post('/api/busUpChannel/getAllUpChannel', params, false),
    // 导出入账
    uploadEarnOrder: params => request.post('/api/uploadEarnOrder', params, false),
    // 业务类型
    getAllBusInfo: params => request.post('/api/business/getAllBusInfo', params, false),
    // 业务列表
    bussinessList: params => request.post('/api/business/list', params, false),
    // 业务列表状态修改
    changeBusStatus: params => request.post('/api/business/changeBusStatus', params, false),
    // 业务品牌
    busBrandList: params => request.post('/api/business/busBrandList', params, false),
    // 业务规则下拉
    getRuleAndCfg: params => request.post('/api/business/getRuleAndCfg', params, false),
    // 业务品牌回显
    getBrandChannelInfo: params => request.post('/api/business/getBrandChannelInfo', params, false),
    // 业务品牌修改
    setBusBrandList: params => request.post("/api/business/saveBrandChannel", params, false),
    // 业务品牌状态修改
    changeBrandStatus: params => request.post('/api/business/changeBrandStatus', params, false),
    // 业务商品上下移
    modifyShopSort: params => request.post('/shopInfo/modifyShopSort', params, false),
    // 业务推广
    BusPromotion: params => request.post('/api/business/getBusPromotionList', params, false),
    // 新建上游链接
    saveBusPromotion: params => request.post('api/business/saveBusPromotion', params, false),
    // 业务推广状态修改
    changeBusPromotionStatus: params => request.post('/api/business/changeBusPromotionStatus', params, false),
    // 业务订单
    getBusOrderCreditList: params => request.post('/api/business/getBusOrderCreditList', params, false),
    // 业务详情
    getBusOrderInfo: params => request.post('/api/business/getBusOrderInfo', params, false),
    // 业务品牌下拉
    getBusChannel: params => request.post('/api/business/getBusChannel', params, false),
    // 结算计算方式
    queryDictLists: params => request.post('/api/sys/dict/queryDictList', params, false),
    // 结算计算方式回显
    getBusPromotion: params => request.post('/api/business/getBusPromotion', params, false),
    // 规则
    getBusRule: params => request.post('/api/business/getBusRule', params, false),
    // 新建商品卡状态
    getRuleCfgByChannel: params => request.post('/api/business/getRuleCfgByChannel', params, false),
    // 点击完成
    addShopBatch: params => request.post('/shopInfo/addShopBatch', params, false),
    // 规则值
    getBusRuleCfg: params => request.post('/api/business/getBusRuleCfg', params, false),
    // 业务配置
    saveBusRuleCost: params => request.post('/api/business/saveBusRuleCost', params, false),
    //回显
    getBusRuleCost: params => request.post('/api/business/getBusRuleCost', params, false),
    // 修改
    updateBusRuleCost: params => request.post('/api/business/updateBusRuleCost', params, false),
    // 修改完成
    changeOfficeBrandStatus: params => request.post('/api/business/changeOfficeBrandStatus', params, false),
    // 机构-业务
    getOfficeBusList: params => request.post('/api/business/getOfficeBusList', params, false),
    // 机构-业务-渠道配置业务
    getDistributeGoodsInfo: params => request.post('/api/business/getDistributeGoodsInfo', params, false),
    // 机构-业务-渠道配置业务完成
    saveDistributeGoodsValue: params => request.post('/api/business/saveDistributeGoodsValue', params, false),
    // 增值渠道
    officeLinklist: params => request.post('/api/business/officeLinklist', params, false),
    // 增值渠道状态改变
    changeOfficeLinkStatus: params => request.post('/api/business/changeOfficeLinkStatus', params, false),
    // 开通业务
    saveOfficeBus: params => request.post('/api/business/saveOfficeBus', params, false),
    // 推广名称
    getBrandChannelType: params => request.post('/api/business/getBrandChannelType', params, false),
    // 修改业务
    getOfficeBus: params => request.post('/api/business/getOfficeBus', params, false),
    // 生成密钥
    generateKey: params => request.post('/api/office/generateKey', params, false),
    // -----------商学院
    //  问题分类  删除
    delProblem: params => request.post("api/school/delConfirm", params, false),
    //保存费率信息
    servicePolicyCfg: params => request.post("api/office/servicePolicyCfg", params, false),
    //回显费率信息
    getServicePolicyCfg: params => request.post("api/office/getServicePolicyCfg", params, false),

    //常见问题列表
    schoolQuestionList: params => request.post('/api/school/schoolQuestionList', params, false),
    //问题分类
    schoolQuestionTypeList: params => request.post('/api/school/schoolQuestionTypeList', params, false),
    //添加问题分类
    saveSchoolQuestionType: params => request.post('/api/school/saveSchoolQuestionType', params, false),
    //回显问题分类
    getSchoolQuestionType: params => request.post('/api/school/getSchoolQuestionType', params, false),
    //添加问题
    saveSchoolQuestion: params => request.post('/api/school/saveSchoolQuestion', params, false),
    //问题分类下拉框
    getAllSchoolQuestionType: params => request.post('/api/school/getAllSchoolQuestionType', params, false),
    //问题分类回显
    getSchoolQuestion: params => request.post('/api/school/getSchoolQuestion', params, false),

    // s首页商学院
    schoolStatisticsTotalQuery: params => request.post('/api/dataStatistics/schoolStatisticsTotalQuery', params, false),
    // s首页代办
    thingsStatisticsTotalQuery: params => request.post('/api/dataStatistics/thingsStatisticsTotalQuery', params, false),
    // 学院课堂 查看更多
    schoolResourceList: params => request.post('/api/school/schoolResourceList', params, false),

    //------------------------------App管理---------------------------
    // 版本控制回显
    getAppVersion: params => request.post('/api/cltPhoto/getAppVersion', params, false),
    // 版本控制创建
    saveAppVersion: params => request.post('/api/cltPhoto/saveAppVersion', params, false),
    // 公告管理列表
    noticeList: params => request.post('/api/notice/noticeList', params, false),
    // 创建公告
    saveNotice: params => request.post('/api/notice/saveNotice', params, false),
    // 回显公告
    getNoticeInfo: params => request.post('/api/notice/getNoticeInfo', params, false),
    // 上下移公告
    changeNoticeSort: params => request.post('/api/notice/changeNoticeSort', params, false),
    // 停启用公告
    updateNoticeSort: params => request.post('/api/notice/updateStatus', params, false),

    //------------------------------活动管理---------------------------
    // 层级返佣活动创建
    saveOfficeBusActive: params => request.post('/api/active/saveOfficeBusActive', params, false),
    // 业务达标活动创建
    saveBusReachActive: params => request.post('/api/active/saveBusReachActive', params, false),
    //------------------------------我的信息---------------------------
    // 账户余额列表
    queryOfficeAccountAmt: params => request.post('/api/office/queryOfficeAccountAmt', params, false),
    // 账户余额信息
    getEmailAccountAmt: params => request.post('/api/office/getEmailAccountAmt', params, false),
    // admin
    openEmailAccount: params => request.post('/api/office/openEmailAccount', params, false),
    // 充值
    doOfficeInOrde: params => request.post('/api/recharge/doOfficeInOrde', params, false),
    // 渠道对公
    queryEmailAccount: params => request.post('/api/office/queryEmailAccount', params, false),
    // 渠道账号改变
    getEmailAccountStatus: params => request.post('/api/office/getEmailAccountStatus', params, false),

    //------------------------------数据管理---------------------------
    // 批次管理列表
    batchManagementList: params => request.post('/api/data/list', params, false),
    // 批次管理导出
    batchManagementExport: params => request.post('/api/data/export', params, false),

    //------------------------------机构管理/机构模板列表---------------------------
    getOfficeTemplate: params => request.post('/api/business/costTemp/getOfficeTemplate', params, false),
    //------------------------------机构管理/模版管理列表---------------------------
    costTempList: params => request.post('/api/business/costTemp/list', params, false),
    //------------------------------机构管理/模板管理/启用-停用---------------------------
    updateTempStatus: params => request.post('/api/business/costTemp/updateTempStatus', params, false),
    //------------------------------机构管理/模板管理/创建模板---------------------------
    getTemplateInfoForInsert: params => request.post('/api/business/costTemp/getTemplateInfoForInsert', params, false),
    //------------------------------机构管理/模板管理/新增-提交---------------------------
    saveTemplate: params => request.post('/api/business/costTemp/saveTemplate', params, false),
    //------------------------------机构管理/模板管理/查看---------------------------
    getTemplateInfo: params => request.post('/api/business/costTemp/getTemplateInfo', params, false),
    //------------------------------接口类型---------------------------
    getOfficeTypeList: () => request.post('/api/sys/dict/queryDictList', {type: 'office_type'}, false),
    //商户管理 / 商户列表 / 查看资质---------------------------
    getMerchantInfo: params => request.post('/api/mer/getMerchantInfo', params, false),
    //支付管理-支付费率---------------------------
    getOEMPayList: params => request.post('/api/onlineBus/getOEMPayList', params, false),
    //开通业务 - 获取支付规则
    pageOnlineJftRoutInfo: params => request.post('/api/onlineBus/pageOnlineJftRoutInfo', params, false),
    //佳付通路由规则详情
    getOemInfoByRouteCode: params => request.post('/api/onlineBus/getOemInfoByRouteCode', params, false),
    //支付规则 新增/修改接口
    saveOnlineRouteInfo: params => request.post('/api/onlineBus/saveOnlineRouteInfo', params, false),
    //修改支付规则停用/启用
    updateOnlineRouteStatus: params => request.post('/api/onlineBus/updateOnlineRouteStatus', params, false),
    // 获取银行列表
    querySysBankList: params => request.post('/api/mer/querySysBankList', params, false),

    //包盘商 模板管理
    templateManagementList: params => request.post('/api/onlineBus/getFeeTemplateList', params, false),
    updateFeeTempStatus: params => request.post('/api/onlineBus/updateFeeTempStatus', params, false),

    //新商城相关接口
    // 商品管理 商品类型 列表
    productTypelist: params => request.post('/api/shop/productTypelist', params, false),
    //商品管理 商品类型 查看
    queryProductType: params => request.post('/api/shop/queryProductType', params, false),
    // 商品管理 商品列表 列表
    cascadeProductType: params => request.post('/api/shop/cascadeProductType', params, false),
    // 商品管理 商品列表 列表 移动
    changeSort: params => request.post('/api/shop/changeSort', params, false),
    // 商品管理 添加商品
    saveShopProduct: params => request.post('/api/shop/saveShopProduct', params, false),
    // 商品管理 修改  回显接口
    getShopProductInfo: params => request.post('/api/shop/getShopProductInfo', params, false),
    // 配置商品 获取列表
    getDistributeShopInfo: params => request.post('/api/shop/getDistributeShopInfo', params, false),
    //商城管理 订单列表
    getShopOrderList: params => request.post('/api/shop/getShopOrderList', params, false),
    // 商城管理 订单派发
    queryShopSellOrderList: params => request.post('/api/shop/queryShopSellOrderList', params, false),
    // 商城管理 库存列表
    getStockList: params => request.post('/api/shop/getStockList ', params, false),
    // 商城管理 商品名称
    queryProductById: params => request.post("/api/shop/queryProductById", params, false),
    // 库存新增
    inStock: params => request.post('/api/shop/inStock', params, false),
    // 商城管理  库存列表 售卖配置
    newSaleConfig: params => request.post("api/shop/saleConfig", params, false),
    // 商城管理 订单派发 查看
    //getSendOrderDetail: params => request.post('/api/shop/getSendOrderDetail', params, false),

    //查询机构开通业务列表
    queryOfficeBusList: params => request.post('/api/office/queryOfficeBusList', params, false),
    //开通业务
    saveOfficeBus2: params => request.post('/api/office/saveOfficeBus', params, false),
    //判断权限 是否为直属
    queryOfficeBusCostAuth: params => request.post('/api/office/queryOfficeBusCostAuth', params, false),
    queryTradeInfo:params => request.post('/api/mer/queryTradeInfo', params, false),
    queryMerAcqSimQueList:params => request.post('/api/mer/queryMerAcqSimQueList', params, false),
    saveMerTidInfo:params => request.post('/api/mer/saveMerTidInfo', params, false),
    queryMerTidInfo:params => request.post('/api/mer/queryMerTidInfo', params, false),

}



// WEBPACK FOOTER //
// ./src/plugins/https.js